import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/images/left.png'
import _imports_1 from '../../public/images/right.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4c3bb3ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbox" }
const _hoisted_2 = { class: "toptab-logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "switch" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "line"
}
const _hoisted_7 = { class: "top1-title" }
const _hoisted_8 = { class: "bottom1" }
const _hoisted_9 = { class: "bottom1-title" }
const _hoisted_10 = { class: "bottom1-top" }
const _hoisted_11 = { class: "bottom1-top-img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "bottom1-midd" }
const _hoisted_15 = { class: "bottom1-midd-num" }
const _hoisted_16 = { class: "bottom1-midd-text" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom1-three" }, "合作伙伴", -1))
const _hoisted_18 = { style: {"display":"flex","width":"100%","justify-content":"center","align-items":"center"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom1-left",
  style: {"margin-right":"-50px"},
  id: "one"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "bottom1-left-img",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_20 = {
  key: 0,
  class: "bottom1-last"
}
const _hoisted_21 = {
  key: 0,
  style: {"width":"100%","display":"flex"}
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  style: {"width":"100%","display":"flex","margin-left":"80px"}
}
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 2,
  style: {"width":"100%","display":"flex"}
}
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 3,
  style: {"width":"100%","display":"flex","margin-left":"80px"}
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 4,
  style: {"width":"100%","display":"flex"}
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 5,
  style: {"width":"100%","display":"flex","margin-left":"80px"}
}
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 6,
  style: {"width":"100%","display":"flex"}
}
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 7,
  style: {"width":"100%","display":"flex","margin-left":"80px"}
}
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  key: 8,
  style: {"width":"100%","display":"flex"}
}
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom1-left",
  style: {"margin-left":"-50px"},
  id: "two"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "bottom1-left-img",
    src: _imports_1,
    alt: ""
  })
], -1))

import { ref, onMounted, nextTick } from "vue";
import { aboutuInfo } from "../api/home.js"
import { useRouter, useRoute } from "vue-router";
import bottomBar from "@/components/bottomBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'contract',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const aboutuList = ref({})

const tabs = ref(["首页", "关于我们", "联系我们"]);
const activeTab = ref<any>(1);
// activeTab.value = localStorage.getItem("activeTab") ? localStorage.getItem("activeTab") : 1;

const clickTab = (index: any) => {
  // localStorage.setItem("activeTab", index.toString());
  activeTab.value = index
  index == 0
    ? router.push("/")
    : index == 1
      ? router.push("/contract")
      : router.push("/about");
};


const isDropdown = ref(false)
const scrolling = (e:any) => {
  if (e.target.scrollTop >= 100) {
    isDropdown.value = true
  } else {
    isDropdown.value = false
  }
}
const getInfo = async () => {
  try {
    const { data } = await aboutuInfo()
    aboutuList.value = data.data
    nextTick(() => {
      getHeight()
    })
  } catch (error) {
    console.log(error)
  }
}


const getHeight = () => {
  const height = document.getElementsByClassName('bottom1-last');
  const ele1 = document.getElementById('one');
  const ele2 = document.getElementById('two');

  if (ele1 !== null && height.length > 0 && height[0] !== null) {
    ele1.style.height = `${height[0].clientHeight}px`;
  }

  if (ele2 !== null && height.length > 0 && height[0] !== null) {
    ele2.style.height = `${height[0].clientHeight}px`;
  }

}


onMounted(() => {
  getInfo()
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "contract",
    onScroll: scrolling
  }, [
    _createElementVNode("div", {
      class: "top1",
      style: _normalizeStyle({ backgroundImage: `url(${aboutuList.value?.top_banner?.image})` })
    }, [
      _createElementVNode("div", {
        class: "toptab",
        style: _normalizeStyle({
      backgroundColor: isDropdown.value ? '#fff' : 'transparent',
      boxShadow:
        isDropdown.value
          ? '0px 2px 7px 0px rgba(152,161,168,0.27)'
          : 'none',
    })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "toptab-logo",
              src: aboutuList.value?.set?.site_logo,
              alt: ""
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["tab", activeTab.value == index ? 'active' : '']),
                style: _normalizeStyle(index == 1 ? 'margin:0 100px' : ''),
                key: index,
                onClick: ($event: any) => (clickTab(index))
              }, [
                (activeTab.value == index)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(item), 1)
              ], 14, _hoisted_5))
            }), 128))
          ])
        ])
      ], 4),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, _toDisplayString(aboutuList.value?.top_banner?.title), 1)
      ])
    ], 4),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(aboutuList.value?.aboutus?.title), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("img", {
            class: "bottom1-top-img",
            src: aboutuList.value?.aboutus?.image,
            alt: ""
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("div", {
          class: "bottom1-top-content",
          innerHTML: aboutuList.value?.aboutus?.intro
        }, null, 8, _hoisted_13)
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.aboutus?.content, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(item.data), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(item.text), 1)
          ]))
        }), 128))
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        (aboutuList.value.links)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (aboutuList.value?.links.length <= 7 && aboutuList.value?.links.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.links.slice(0, 7), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "bottom1-last-case",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          class: "bottom1-last-case-img",
                          src: item.image,
                          alt: ""
                        }, null, 8, _hoisted_22)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (aboutuList.value?.links.length < 13 && aboutuList.value?.links.length > 7)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.links.slice(7, 13), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "bottom1-last-case",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          class: "bottom1-last-case-img",
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_24)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (aboutuList.value?.links.length < 20 && aboutuList.value?.links.length > 13)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.links.slice(13, 20), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "bottom1-last-case",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          class: "bottom1-last-case-img",
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_26)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (aboutuList.value?.links.length < 26 && aboutuList.value?.links.length > 20)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.links.slice(20, 26), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "bottom1-last-case",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          class: "bottom1-last-case-img",
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_28)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (aboutuList.value?.links.length < 33 && aboutuList.value?.links.length > 26)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.links.slice(26, 33), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "bottom1-last-case",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          class: "bottom1-last-case-img",
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_30)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (aboutuList.value?.links.length < 39 && aboutuList.value?.links.length > 33)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.links.slice(33, 39), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "bottom1-last-case",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          class: "bottom1-last-case-img",
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_32)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (aboutuList.value?.links.length < 46 && aboutuList.value?.links.length > 39)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.links.slice(39, 46), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "bottom1-last-case",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          class: "bottom1-last-case-img",
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_34)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (aboutuList.value?.links.length < 46 && aboutuList.value?.links.length > 52)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.links.slice(46, 52), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "bottom1-last-case",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          class: "bottom1-last-case-img",
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_36)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (aboutuList.value?.links.length < 60 && aboutuList.value?.links.length > 52)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutuList.value?.links.slice(52, 60), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "bottom1-last-case",
                        key: index
                      }, [
                        _createElementVNode("img", {
                          class: "bottom1-last-case-img",
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_38)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_39
      ])
    ]),
    (aboutuList.value.links)
      ? (_openBlock(), _createBlock(bottomBar, { key: 0 }))
      : _createCommentVNode("", true)
  ], 32))
}
}

})